const UserProvider = ({ accounts, children }) =>
  children({ currentUser: accounts.currentUser });

UserProvider.propTypes = {};

// prettier-ignore
export default UserProvider;
